'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/store';
import { setSentryLogContext, syncSentryBaseScope } from '@/lib/sentryLogs';

export function SentryScopeSync() {
  const currentUser = useSelector((state: RootState) => state.user.currentUser);
  const currentTeam = useSelector((state: RootState) => state.team.currentTeam);

  useEffect(() => {
    setSentryLogContext({ currentUser, currentTeam });
    syncSentryBaseScope();

    if (!currentUser) {
      Sentry.setUser(null);
      Sentry.setTag('auth_state', 'logged_out');
      Sentry.setTag('team_id', 'none');
      Sentry.setTag('team_role', 'none');
      Sentry.setContext('workspace', null);
      return;
    }

    Sentry.setUser({
      id: currentUser.user_id,
      email: currentUser.email,
      username: currentUser.nickname || currentUser.name || currentUser.username,
    });

    Sentry.setTag('auth_state', 'logged_in');
    Sentry.setTag('team_id', currentTeam?.team_id ?? 'none');
    Sentry.setTag('team_role', currentTeam?.my_role ?? 'none');
    Sentry.setContext('workspace', {
      teamId: currentTeam?.team_id ?? null,
      teamName: currentTeam?.name ?? null,
      teamRole: currentTeam?.my_role ?? null,
      teamCount: currentUser.teams?.length ?? 0,
    });
  }, [currentTeam, currentUser]);

  return null;
}
